import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
    selector: '[appScrollAnimation]',
})
export class ScrollAnimationDirective implements OnInit {
    constructor(private elementRef: ElementRef, private renderer: Renderer2) { }

    ngOnInit(): void {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.playAnimation();
                }
            });
        });

        observer.observe(this.elementRef.nativeElement);
    }

    playAnimation(): void {
        this.renderer.addClass(this.elementRef.nativeElement, 'animated-class');
    }
}
//-----------------------------------------------

//new animation while scrolling

// import { Directive, ElementRef, Renderer2 } from '@angular/core';

// @Directive({
//     selector: '[appScrollAnimation]',
// })
// export class ScrollAnimationDirective {
//     myDate = new Date();
//     constructor(private elementRef: ElementRef, private renderer: Renderer2) {
//         this.elementRef.nativeElement.style.visibility = 'hidden';
//         window.addEventListener('scroll', () => {
//             const viewportHeight = window.innerHeight;
//             if (2 * (this.elementRef.nativeElement.getBoundingClientRect().top) <
//                 1.5 * (viewportHeight)
//             ) {
//                 this.elementRef.nativeElement.style.visibility = 'visible';
//                 this.elementRef.nativeElement.classList.add('animated-class');
//                 console.log("string ", this.myDate.toString());
//                 console.log("sp ", this.myDate);

//             }
//         });
//     }
// }